import { ShieldAlert } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const ScamWarning = ({ className = "" }) => (
  <div data-testid="scam-warning" className={`flex gap-4 bg-amber-50 border border-amber-200 text-amber-900 p-6 rounded-lg ${className}`}>
    <ShieldAlert className="h-6 w-6 shrink-0 text-amber-700" />
    <div className="space-y-1">
      <p className="font-display font-semibold">Payment safety notice</p>
      <p className="text-sm leading-relaxed">
        SLN Agro Exports only shares bank details from its official email, <strong>{COMPANY.email}</strong>. We never
        change bank details by WhatsApp or phone. If you receive a request to pay a different account, call us on{" "}
        {COMPANY.phoneDisplay} before you pay.
      </p>
    </div>
  </div>
);
